import React, { useMemo, useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import cn from 'classnames';
import { TOTAL_SLOTS, slotToLabel, SLOT_MINUTES, slotToTimeStr, timeToSlot } from '../../helpers/office_helpers';
import './OfficeClockTimeReadout.scss';

const OfficeClockTimeReadout = ({
  hasRange,
  localStart,
  localEnd,
  dayPrefix,
  selectedTime,
  selectedEndTime,
  setLocalStart,
  setLocalEnd,
  setSelectedTime,
  setSelectedEndTime
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const timeOptions = useMemo(() => {
    const opts = [];
    for (let slot = 0; slot <= TOTAL_SLOTS; slot++) {
      opts.push({ value: slot, label: slotToLabel(slot, true) });
    }
    return opts;
  }, []);

  const handleStartChange = option => {
    const newStart = option.value;
    setLocalStart(newStart);
    setSelectedTime(slotToTimeStr(newStart));

    // Auto-adjust end time if needed
    if (hasRange && localEnd <= newStart) {
      const newEnd = Math.min(newStart + 4, TOTAL_SLOTS); // default 1 hour later
      setLocalEnd(newEnd);
      setSelectedEndTime(slotToTimeStr(newEnd));
    }
  };

  const handleEndChange = option => {
    const newEnd = option.value;
    setLocalEnd(newEnd);
    setSelectedEndTime(slotToTimeStr(newEnd));

    if (newEnd <= localStart) {
      const newStart = Math.max(newEnd - 4, 0); // default 1 hour before
      setLocalStart(newStart);
      setSelectedTime(slotToTimeStr(newStart));
    }
  };

  const showRange = hasRange || isFocused;
  const startLength = slotToLabel(localStart).length;
  const endLength = localEnd ? slotToLabel(localEnd).length : undefined;

  return (
    <div className='clock-time-readout' onFocus={() => setIsFocused(true)} onBlur={() => setIsFocused(false)}>
      <div className='clock-time-readout-dropdowns'>
        <Select
          options={timeOptions}
          value={timeOptions.find(o => o.value === localStart)}
          onChange={handleStartChange}
          className='time-select start'
          classNamePrefix='time-select'
          menuPortalTarget={document.body}
          styles={{
            menuPortal: base => ({ ...base, zIndex: 12 }),
            control: base => ({ ...base, width: 140 })
          }}
        />
        <span className={cn('time-separator', showRange && 'visible')}>—</span>
        <Select
          options={timeOptions.filter(o => o.value > localStart)}
          value={timeOptions.find(o => (localEnd ? o.value === localEnd : o.value === localStart))}
          onChange={handleEndChange}
          className={cn('time-select end', showRange && 'visible')}
          classNamePrefix='time-select'
          menuPortalTarget={document.body}
          styles={{
            menuPortal: base => ({ ...base, zIndex: 12 }),
            control: base => ({ ...base, width: 140 })
          }}
        />
      </div>
      <div className='time-meta-inline'>
        {dayPrefix && <span className='time-day-prefix'>{dayPrefix}</span>}
        <span className={cn('time-duration', hasRange && 'visible')}>{(localEnd - localStart) * SLOT_MINUTES} min</span>
      </div>
    </div>
  );
};

export default OfficeClockTimeReadout;
